import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ScrollTop } from 'primereact/scrolltop';
import { useSelector } from 'react-redux';
import MainLoader from '../components/loaders/mainLoader.js';
import TopBar from '../components/topBar/TopBar.js';
import MainHeader from '../components/MainHeader/MainHeader.jsx';
import TopMenu from '../components/navbar/TopMenu.js';
import Footer from '../components/footer/Footer.js';
import NoData from '../components/NoData/NoData.jsx';
import Home from '../pages/Home/Home.jsx';
import Login from '../pages/Auth/Login.jsx';
import Register from '../pages/Auth/Register.jsx';
import Otp from '../pages/Auth/Otp.jsx';
import ForgetPassword from '../pages/Auth/ForgetPassword.jsx';
import ResetPassword from '../pages/Auth/ResetPassword.jsx';
import ForgetPasswordOtp from '../pages/Auth/ForgetPasswordOtp.jsx';
import Category from '../pages/Category/Category.jsx';
import VendorApply from '../pages/VendorApply/VendorApply.jsx';
import VendorWizard from '../pages/VendorApply/VendorWizard.jsx';
import ProductDetails from '../pages/ProductDetails/ProductDetails.jsx';
import Compare from '../pages/Profile/Compare/Compare.jsx';
import Cart from '../pages/Cart/Cart';
import Orders from '../pages/Orders/Orders';
import OrderDetails from '../pages/Orders/OrderDetails/OrderDetails';
import Checkout from '../pages/Checkout/Checkout';
import Profile from '../pages/Profile/Profile.jsx';
import MyProfile from '../pages/Profile/MyProfile.jsx';
import Wishlist from '../pages/Profile/Wishlist.jsx';
import ValidateEmailOtp from '../pages/Auth/ValidateEmailOtp.jsx';
import Notification from '../pages/Profile/Notification/Notification.jsx';
import ProductsSearch from '../pages/ProductsSearch/ProductsSearch.jsx';
import Brands from '../pages/Brands/Brands.jsx';
import ProductAssociate from '../pages/ProductDetails/ProductAssociate.jsx';
import VendorProducts from '../pages/Vendor/VendorProducts.jsx';
import TagProducts from '../pages/Category/TagProducts.jsx';
import TermsAndCondition from '../pages/UsefulLinks/TermsAndCondition.jsx';
import PrivacyPolicy from '../pages/UsefulLinks/PrivacyPolicy.jsx';
import ContactUs from '../pages/UsefulLinks/ContactUs.jsx';

const NonAuthLayout = () => {
    const { userType } = useSelector((state) => state.authReducer);
    return (
        <>
            <MainLoader />
            <TopBar />
            <MainHeader />
            <TopMenu />

            <Routes>
                <Route path="/" element={<Home />} />,
                <Route path="/login" element={<Login />} />,
                <Route path="/register" element={<Register />} />,
                <Route path="/otp" element={<Otp />} />,
                <Route path="/verify-email" element={<ValidateEmailOtp />} />,
                <Route path="/forget-password" element={<ForgetPassword />} />,
                <Route path="/reset-password" element={<ResetPassword />} />,
                <Route path="/forget-password-otp" element={<ForgetPasswordOtp />} />,
                <Route path="/search/:keyword/" element={<ProductsSearch />} />,
                <Route path="/product-details/:id" element={<ProductDetails />} />,
                <Route path="/product-details/:id/assoicate/" element={<ProductAssociate />} />,
                <Route
                    path="/product-details/:id/assoicate/:assoicateId"
                    element={<ProductAssociate />}
                />
                ,
                <Route path="/category/:name/:id" element={<Category />} />,
                <Route path="/tag/:id" element={<TagProducts />} />
                <Route path="/cart/:couponId" element={<Cart />} />,
                <Route path="/orders" element={<Orders />} />,
                <Route path="/orders/:orderId" element={<OrderDetails />} />,
                <Route path="/checkout/:addressId/:couponId" element={<Checkout />} />,
                <Route path="/brands" element={<Brands />} />,
                <Route path="/brand/:name/:id" element={<Brands />} />,
                {userType !== 1 && <Route path="/vendor-apply" element={<VendorApply />} />},
                {userType !== 1 && <Route path="/vendor-wizard" element={<VendorWizard />} />},
                <Route path="/vendor/vendor-products/:id" element={<VendorProducts />} />
                <Route path="/compare" element={<Compare />} />,
                <Route path="/wishlist" element={<Wishlist />} />,
                <Route path="/notification" element={<Notification />} />,
                <Route path="/profile" element={<Profile />}>
                    <Route index element={<MyProfile />} />
                    <Route path="profile" element={<MyProfile />} />
                </Route>
                <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="*" element={<NoData />} />
            </Routes>

            <Footer />

            <ScrollTop className="scroll-top-icon" />
        </>
    );
};

export default NonAuthLayout;
